import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { RelatedProductsMappingItem } from 'src/app/Models/relatedProductsMappingItem.model';
import * as feather from 'feather-icons';
import { Clipboard } from '@angular/cdk/clipboard';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-photo-carousel',
  templateUrl: './photo-carousel.component.html',
  styleUrls: ['./photo-carousel.component.scss']
})
export class PhotoCarouselComponent implements OnInit, AfterViewInit {

  @Input()
  relatedProducts: RelatedProductsMappingItem[];
  constructor(private clipboard: Clipboard, private toastr: ToastrService) { }

  ngOnInit() {
    console.log('Related Products:', this.relatedProducts);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      feather.replace();
    });
  }

  copySku(sku: string): void {
    console.log('Sku:', sku);
    if (sku) {
      this.clipboard.copy(sku);
      this.toastr.success('SKU copied to clipboard');
    }
  }

  owlcarousel1Options = {
    loop: true,
    margin: 10,
    nav: false,
    responsive: {
      0: {
        items: 4
      },
      400: {
        items: 4
      },
      740: {
        items: 4
      },
      940: {
        items: 4
      }
    },
  };
  // loop: true,
  //   mouseDrag: false,
  //   touchDrag: false,
  //   pullDrag: false,
  //   dots: false,
  //   navSpeed: 700,
  //   navText: ['', ''],
  //   responsive: {
  //     0: {
  //       items: 1
  //     },
  //     400: {
  //       items: 2
  //     },
  //     740: {
  //       items: 3
  //     },
  //     940: {
  //       items: 4
  //     }
  //   },
  //   nav: true
  // }
}
